import { format, parse, parseISO } from "date-fns";

const DATE_TIME_INPUT_FORMAT = "yyyy-MM-dd'T'HH:mm";
const DATE_TIME_STORAGE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

const PARSE_FORMATS = [
  "yyyy-MM-dd'T'HH:mm",
  "yyyy-MM-dd HH:mm",
  "yyyy-MM-dd h:mm a",
  "yyyy-MM-dd ha",
  "MMM d yyyy h:mm a",
  "MMMM d yyyy h:mm a",
  "MMM d, yyyy h:mm a",
  "MMMM d, yyyy h:mm a",
];

export function formatDateTimeShortcutInput(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }

  return format(date, DATE_TIME_INPUT_FORMAT);
}

export function parseDateTimeShortcutInput(value, now = new Date()) {
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  const lower = trimmed.toLowerCase();
  if (lower === "now") return now;
  if (lower === "today") return now;

  const isoParsed = parseISO(trimmed);
  if (!Number.isNaN(isoParsed.getTime())) {
    return isoParsed;
  }

  for (const dateFormat of PARSE_FORMATS) {
    const parsed = parse(trimmed, dateFormat, now);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  return null;
}

export function formatDateTimeShortcutStorage(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return format(date, DATE_TIME_STORAGE_FORMAT);
}
